export var REMOVE_DEVICE_OPTION_ID = 'REMOVE_DEVICE_OPTION_ID';
export var VIEW_CONTENT_ACTIVITY = 'VIEW_CONTENT_ACTIVITY';